<div
  class="dropdown dropdown-end"
  marketClickOutside
  (clickOutside)="isOpen.set(false)">
  <div
    tabindex="0"
    role="button"
    class="btn btn-circle btn-ghost btn-sm"
    (click)="openNotiHandler()"
    aria-hidden="true">
    <div class="indicator">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
      </svg>
      @if (unread) {
        <span class="badge indicator-item badge-primary badge-xs">{{
          unread
        }}</span>
      }
    </div>
  </div>
  <ul
    tabindex="0"
    class="menu dropdown-content z-[1] w-[50vw] min-w-[300px] overflow-hidden rounded-box bg-base-100 p-0 shadow">
    @if (data$ | async; as notifications) {
      <div
        infinite-scroll
        [scrollWindow]="false"
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        (scrolled)="onScroll(notifications)"
        class="no-scrollbar max-h-[50vh] overflow-y-auto">
        @for (item of notifications.items; track $index) {
          <li
            [ngClass]="{ 'bg-base-300': item.read }"
            (click)="markRead(item)"
            aria-hidden="true">
            @if (item.navigation) {
              <a
                [routerLink]="item.navigation.routing"
                [queryParams]="item.navigation.params"
                class="block">
                <ng-container
                  [ngTemplateOutlet]="noti"
                  [ngTemplateOutletContext]="{ item: item }"></ng-container>
              </a>
            } @else {
              <div class="block">
                <ng-container
                  [ngTemplateOutlet]="noti"
                  [ngTemplateOutletContext]="{ item: item }"></ng-container>
              </div>
            }
          </li>
        } @empty {
          @if (!loading()) {
            <p class="col-span-2 text-center">Không tìm thấy sản phẩm nào</p>
          }
        }
        @if (loading()) {
          <div class="col-span-2 flex w-full justify-center">
            <span class="loading loading-dots loading-lg"></span>
          </div>
        }
      </div>
      <div class="flex w-full justify-end">
        <button
          class="btn btn-ghost btn-sm flex items-center justify-end gap-1 py-1 pr-2 text-primary"
          (click)="markAllNoti()">
          <market-icon iconName="check"></market-icon>
          <span>Đánh dấu đã đọc tất cả </span>
        </button>
      </div>
    }
  </ul>
</div>

<ng-template #noti let-item="item">
  <p>
    {{ item.text }}
  </p>
  <small>
    {{ item.createdDate | date: 'dd/MM/YYYY hh:mm a' }}
    @if (item.read) {
      <span>Đã xem</span>
    }
  </small>
</ng-template>
